import { defineComponent as _defineComponent } from 'vue'
import CardSectionAwardsItem from './CardSectionAwardsItem.vue';
import { AbSlider, AbSliderItem } from '../../../ui';

interface Props {
  awards: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionAwardsSlider',
  props: {
    awards: null
  },
  setup(__props: any) {



return { __sfc: true,CardSectionAwardsItem, AbSlider, AbSliderItem }
}

})